module.exports = __webpack_public_path__ + "static/media/iconoFlechaArribaAzul.48f01f48.svg";